
import React, { Component } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';

class SmallImages extends Component {
    constructor() {
        super();
        this.state = {
            nav2: null
        }
    }
    componentDidMount() {
        this.setState({
            nav2: this.slider2
        });
    }

    resizeCompleteLook(length) {
        return length <= 2 ? 'col-6 p-0' : 'col-12 p-0'
    }
    // handleImage(imgPath){
    //      localStorage.removeItem('selectedImage')
    //     localStorage.setItem('selectedImage',imgPath);    
    // }
    render() {
        const { item, settings,navOne, productLoading ,slider2} = this.props;
        
        var productsnav = {

            asNavFor: navOne,
            ref: slider2,
            slidesToShow: 3,
            focusOnSelect: true,
            arrows: true,
            infinite: true,
            swipeToSlide: false,
        };

        // this.setState({code : initCode})

       // var productsnav = settings; 
        // 
        if(item && item.original && item.original.length <= 1){
            return null
        }
        
        return (
            <div className="row" style={{width:'inherit'}}>
                <div className="col-12 p-0">
                {/* <div className={item && this.resizeCompleteLook(item && item.length)}> */}
                    <Slider {...productsnav} 
           className="small-images">
                        {
                            !productLoading && item && item.map((itm, index) => {
                                return (
                                    <div key={index}>
                                         {/* <Link to={'/PD/' + this.props.lot_code}>  */}
                                            <img src={itm.PIM_IMAGE_FILE_NAME} key={index} alt={itm.PIM_IMAGE_FILE_NAME} className="img-fluid" style={{width:'70%',margin:'0 auto'}}  />
                                         {/* </Link>  */}
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
        );
    }
}

export default SmallImages;